import { ArchiveLockIcon } from './ArchiveLockIcon';

/**
 * author: Colton Wiscombe
 * id 52016536-6E90-4C85-891F-5A9183313497
 * name archive-lock
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-lock.svg
 * tags
 * - Lock 
 */
export const BoxLockIcon = ArchiveLockIcon;
export default BoxLockIcon